import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=1c8d6cf9&scoped=true&"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./RequestPasswordReset.vue?vue&type=style&index=0&id=1c8d6cf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d6cf9",
  null
  
)

export default component.exports